import React, { useEffect, useState } from "react";
import "./Home.css"; // आता स्टाइल external CSS मध्ये (किंवा inline ठेवू शकता)

const Home = () => {
  const villageName = "";
  const heroImages = [
    "/images/phto1.jpeg",
    "/images/phto2.jpeg",
    "/images/phto3.jpeg",
    "/images/phto4.jpeg",
    "/images/phto5.jpeg",
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  const sarpanch = {
    name: "श्री दिनेशराव बी. चौधरी",
    photo: "/images/sarpanch.jpeg",
  };

  const upsarpanch = {
    name: "श्री दिलीपराव गो. बारंगे",
    photo: "/images/upsarpanch1.jpeg",
  };

  const members = [
    { sr: 1, name: "श्री लुकेश का. लोखंडे", ward: "--" },
    { sr: 2, name: "श्री प्रविण पु. चौधरी", ward: "--" },
    { sr: 3, name: "शौ चंदाताई शि. धाटे", ward: "--" },
    { sr: 4, name: "शौ दीक्षाताई भा. डोंगरे", ward: "--" },
    { sr: 5, name: "शौ कांताबाई रा. बैगणे", ward: "--" },
    { sr: 6, name: "शौ संगिता वि.कडवे", ward: "--" },
  ];

  const SafeImage = ({ src, alt }) => {
    const fallback = "https://via.placeholder.com/300x300/D3D3D3/666666?text=फोटो+नाही";
    const [img, setImg] = useState(src);

    return (
      <img
        src={img}
        alt={alt}
        onError={() => setImg(fallback)}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    );
  };

  return (
    <div className="home-container">
      {/* Hero Slider */}
      <section className="hero">
        {heroImages.map((img, i) => (
          <div
            key={i}
            className={`hero-slide ${currentSlide === i ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>        ग्रामपंचायत बोरी आपले स्वागत आहे {villageName}</h1>
            <p>आमच्या गावाचा सर्वांगीण विकास हेच आमचे ध्येय!</p>
             <a href="/aboutus">अधिक माहिती</a>
          </div>
        </div>
      </section>

      {/* Leaders & Table Section */}
      <section className="section">
        <h2 className="title">ग्रामपंचायत प्रतिनिधी</h2>
        <div className="layout">
          {/* Leaders Cards */}
          <div className="leaders">
            <div className="leader-card sarpanch-card">
              <div className="leader-img">
                <SafeImage src={sarpanch.photo} alt="सरपंच" />
              </div>
              <h3>सरपंच</h3>
              <b>{sarpanch.name}</b>
            </div>

            <div className="leader-card upsarpanch-card">
              <div className="leader-img">
                <SafeImage src={upsarpanch.photo} alt="उपसरपंच" />
              </div>
              <h3>उपसरपंच</h3>
              <b>{upsarpanch.name}</b>
            </div>
          </div>

          {/* Members Table */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>सदस्याचे नाव</th>
                  <th>संपर्क</th>
                </tr>
              </thead>
              <tbody>
                {members.map((m) => (
                  <tr key={m.sr}>
                    <td>{m.sr}</td>
                    <td>{m.name}</td>
                    <td>{m.ward}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;